import React from 'react';
import PropTypes from 'prop-types';

/**
 * Step#0 Icon
 * @returns {JSX.Element}
 */
function Personal() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24">
      <g transform="translate(0 0)">
        <path d="M-192.7-111.231a6,6,0,0,0,6-6,6,6,0,0,0-6-6,6,6,0,0,0-6,6A6.007,6.007,0,0,0-192.7-111.231Zm0-10a4,4,0,0,1,4,4,4,4,0,0,1-4,4,4,4,0,0,1-4-4A4.005,4.005,0,0,1-192.7-121.231Z" transform="translate(203.704 123.231)" />
        <path d="M-183.38-107.881a2.983,2.983,0,0,0-2.928-2.35H-199.1a2.984,2.984,0,0,0-2.929,2.35l-1.652,7.433a1,1,0,0,0,.758,1.193,1,1,0,0,0,.218.024h20a1,1,0,0,0,1-1,1.007,1.007,0,0,0-.024-.219Zm-4.824-.35h1.9a1,1,0,0,1,.977.783l1.381,6.217h-17.507l1.381-6.217a1,1,0,0,1,.977-.783h10.9Z" transform="translate(203.704 123.231)" />
      </g>
    </svg>
  );
}

/**
 * Step#1 Icon
 * @returns {JSX.Element}
 */
function TradeIn() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42.462" height="27.085" viewBox="0 0 42.462 27.085">
      <g transform="translate(0 0)">
        <path d="M56.05,50.754l-7.925-1.5a2.367,2.367,0,0,1-1.155-.665l-3.055-3.183A4.615,4.615,0,0,0,40.605,44H30.76a4.6,4.6,0,0,0-2.271.6l-9.021,5.138a4.574,4.574,0,0,0-2.28,4.571l.192,1.5a4.6,4.6,0,0,0,4.552,4h.912a4.375,4.375,0,0,0,8.478,0H43.45a4.375,4.375,0,0,0,8.478,0h3.094a4.588,4.588,0,0,0,1.028-9.059Zm-4.122,6.851a4.375,4.375,0,0,0-8.478,0H31.322a4.375,4.375,0,0,0-8.478,0h-.912a2.384,2.384,0,0,1-2.36-2.076l-.193-1.5a2.372,2.372,0,0,1,1.182-2.371l9.021-5.138a2.386,2.386,0,0,1,1.178-.312h9.845a2.394,2.394,0,0,1,1.718.732l3.055,3.183a4.61,4.61,0,0,0,2.283,1.293l7.924,1.5a2.381,2.381,0,0,1-.562,4.694ZM47.689,60.9a2.189,2.189,0,1,1,2.189-2.189A2.192,2.192,0,0,1,47.689,60.9Zm-22.8-2.189A2.189,2.189,0,1,1,27.082,60.9,2.191,2.191,0,0,1,24.894,58.709Z" transform="translate(-17.151 -36.02)" />
        <path d="M51.584,43.368l1.246,1.246H44.246a1.011,1.011,0,1,0,0,2.022H52.83l-1.246,1.246a1.012,1.012,0,0,0,1.431,1.431l2.973-2.973a1.011,1.011,0,0,0,0-1.431l-2.973-2.973a1.012,1.012,0,0,0-1.431,1.431Z" transform="translate(-14.44 -36.266)" />
        <path d="M42.173,44.444a1.011,1.011,0,1,0,1.431-1.43l-1.246-1.247h8.584a1.011,1.011,0,1,0,0-2.022H42.357L43.6,38.5a1.012,1.012,0,0,0-1.431-1.431L39.2,40.041a1.011,1.011,0,0,0,0,1.431Z" transform="translate(-14.89 -36.772)" />
      </g>
    </svg>
  );
}

/**
 * Step#2 Icon
 * @returns {JSX.Element}
 */
function Services() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.644" height="5.654" viewBox="0 0 23.644 5.654">
      <path d="M-116.252-86.059a2.827,2.827,0,0,1-2.826,2.827,2.827,2.827,0,0,1-2.827-2.827,2.827,2.827,0,0,1,2.827-2.827A2.827,2.827,0,0,1-116.252-86.059Zm6.169-2.827a2.827,2.827,0,0,0-2.826,2.827,2.827,2.827,0,0,0,2.826,2.827,2.827,2.827,0,0,0,2.827-2.827A2.827,2.827,0,0,0-110.083-88.886Zm9,0a2.827,2.827,0,0,0-2.827,2.827,2.827,2.827,0,0,0,2.827,2.827,2.827,2.827,0,0,0,2.826-2.827A2.827,2.827,0,0,0-101.087-88.886Z" transform="translate(121.905 88.886)" />
    </svg>
  );
}

/**
 * Step#3 Icon
 * @returns {JSX.Element}
 */
function Payment() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
      <path d="M-45.23-112.267h-1v-4a1,1,0,0,0-1-1h-4v-3a1,1,0,0,0-1-1h-13a3,3,0,0,0-3,3v16a3,3,0,0,0,3,3h18a1,1,0,0,0,1-1v-4h1a1,1,0,0,0,1-1v-6A1,1,0,0,0-45.23-112.267Zm-20-7h12v2h-12a1,1,0,0,1-1-1A1,1,0,0,1-65.23-119.267Zm17,18h-17a1,1,0,0,1-1-1v-13.172a3.436,3.436,0,0,0,1,.172h17v3h-1a4,4,0,0,0-4,4,4,4,0,0,0,4,4h1Zm2-5h-3a2,2,0,0,1-2-2,2,2,0,0,1,2-2h3Z" transform="translate(68.23 121.267)" />
      <circle cx="1" cy="1" r="1" transform="translate(18.31 12)" />
    </svg>
  );
}

/**
 * Step#4 Icon
 * @returns {JSX.Element}
 */
function Documents() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="26" viewBox="0 0 19.5 26">
      <path d="M-99.583-103.731v-18.417a1.084,1.084,0,0,0-1.083-1.083H-118a1.084,1.084,0,0,0-1.083,1.083v23.833A1.083,1.083,0,0,0-118-97.231h11.917a1.087,1.087,0,0,0,.766-.317l5.417-5.417A1.207,1.207,0,0,0-99.583-103.731Zm-17.333-17.333h15.167v16.25h-4.333a1.084,1.084,0,0,0-1.083,1.083V-99.4h-9.75ZM-105-100.93v-1.718h1.718Z" transform="translate(119.083 123.231)" />
      <path d="M-114.083-111.564A1.083,1.083,0,0,0-113-110.481h6.5a1.083,1.083,0,0,0,1.083-1.083,4.315,4.315,0,0,0-1.754-3.461,3.219,3.219,0,0,0,.671-1.955,3.25,3.25,0,0,0-3.25-3.25,3.25,3.25,0,0,0-3.25,3.25,3.219,3.219,0,0,0,.671,1.955A4.318,4.318,0,0,0-114.083-111.564Zm2.458-1.083a2.165,2.165,0,0,1,2.958-.793,2.169,2.169,0,0,1,.794.793Zm.792-4.333a1.084,1.084,0,0,1,1.083-1.083,1.084,1.084,0,0,1,1.083,1.083,1.083,1.083,0,0,1-1.083,1.083A1.084,1.084,0,0,1-110.833-116.981Z" transform="translate(119.5 123.481)" />
      <path d="M-115-108.064h10.833a1.083,1.083,0,0,0,1.083-1.083,1.084,1.084,0,0,0-1.083-1.083H-115a1.084,1.084,0,0,0-1.083,1.083A1.083,1.083,0,0,0-115-108.064Z" transform="translate(119.333 124.314)" />
      <path d="M-115-105.064h5.417a1.083,1.083,0,0,0,1.083-1.083,1.084,1.084,0,0,0-1.083-1.083H-115a1.084,1.084,0,0,0-1.083,1.083A1.083,1.083,0,0,0-115-105.064Z" transform="translate(119.333 124.564)" />
      <path d="M-109.583-104.231H-115a1.084,1.084,0,0,0-1.083,1.083A1.083,1.083,0,0,0-115-102.064h5.417a1.083,1.083,0,0,0,1.083-1.083A1.084,1.084,0,0,0-109.583-104.231Z" transform="translate(119.333 124.814)" />
    </svg>
  );
}

/**
 * Step#5 Icon
 * @returns {JSX.Element}
 */
function Summary() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.25" height="23" viewBox="0 0 17.25 23">
      <g transform="translate(0 0)">
        <path d="M-9.733-124.639h-11.5a.92.92,0,0,0-.581.241l-4.107,4.107a.9.9,0,0,0-.241.581v17.25a.821.821,0,0,0,.821.821H-9.733a.821.821,0,0,0,.821-.821v-21.357A.822.822,0,0,0-9.733-124.639Zm-12.321,2.8v1.3h-1.3Zm11.5,18.553H-24.518v-15.607h3.286a.821.821,0,0,0,.821-.821V-123h9.857Z" transform="translate(26.161 124.639)" />
        <path d="M-13.005-113.852h1.972a.658.658,0,0,0,.658-.658v-1.972a.658.658,0,0,0-.658-.658h-1.972a.658.658,0,0,0-.658.658v1.972A.658.658,0,0,0-13.005-113.852Z" transform="translate(23.929 123.3)" />
        <path d="M-21.34-115.639a.821.821,0,0,0-.821.821.821.821,0,0,0,.821.821h4.107a.821.821,0,0,0,.821-.821.822.822,0,0,0-.821-.821Z" transform="translate(25.447 123.032)" />
        <path d="M-13.005-107.981h1.972a.658.658,0,0,0,.658-.658v-1.972a.658.658,0,0,0-.658-.658h-1.972a.658.658,0,0,0-.658.658v1.972A.658.658,0,0,0-13.005-107.981Z" transform="translate(23.929 122.251)" />
        <path d="M-21.34-109.767a.821.821,0,0,0-.821.821.821.821,0,0,0,.821.821h4.107a.822.822,0,0,0,.821-.821.821.821,0,0,0-.821-.821Z" transform="translate(25.447 121.983)" />
        <path d="M-13.005-102.11h1.972a.658.658,0,0,0,.658-.657v-1.973a.658.658,0,0,0-.658-.657h-1.972a.658.658,0,0,0-.658.657v1.973A.658.658,0,0,0-13.005-102.11Z" transform="translate(23.929 121.203)" />
        <path d="M-21.34-103.9a.821.821,0,0,0-.821.821.821.821,0,0,0,.821.821h4.107a.822.822,0,0,0,.821-.821.822.822,0,0,0-.821-.821Z" transform="translate(25.447 120.935)" />
      </g>
    </svg>
  );
}

/**
 * Step#6 Icon
 */
function PayPal() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22.621" height="27.5" viewBox="0 0 22.621 27.5">
      <path id="brand-assets-payment-paypal-icon-oneline-svgrepo-com" d="M14.67,29.5H9.681A1,1,0,0,1,8.7,28.327L10.79,16.418a1,1,0,0,1,1.243-.793,9.881,9.881,0,0,0,5.419-.152,6.876,6.876,0,0,0,4.508-5.038c.609-2.207.464-3.878-.43-4.967a5.053,5.053,0,0,0-4.139-1.453l-.073,0H9.185l-3.02,19.7H7.71a1,1,0,0,1,0,2H5a1,1,0,0,1-.988-1.151l3.326-21.7a1,1,0,0,1,.988-.849h8.958A6.972,6.972,0,0,1,23.076,4.2c1.33,1.621,1.6,3.9.812,6.768a8.844,8.844,0,0,1-5.791,6.4,11.7,11.7,0,0,1-5.515.412L10.872,27.5h2.959l1.209-6.857a1,1,0,0,1,1.051-.824,8.182,8.182,0,0,0,4.725-1.465,9.044,9.044,0,0,0,3.837-5.348,1,1,0,1,1,1.935.505,11.168,11.168,0,0,1-9.723,8.3l-1.21,6.862A1,1,0,0,1,14.67,29.5Z" transform="translate(-4 -2)" />
    </svg>
  );
}

/**
 * Arrow
 * @returns {JSX.Element}
 */
function Arrow({ className = '' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.195 7.509" className={className}>
      <g>
        <line x2="6.35" y2="5.24" transform="translate(1.748 1.135)" fill="none" strokeLinecap="round" strokeWidth="1" />
        <line x1="6.35" y2="5.24" transform="translate(8.098 1.135)" fill="none" strokeLinecap="round" strokeWidth="1" />
      </g>
    </svg>
  );
}

Arrow.propTypes = {
  className: PropTypes.string,
};

Arrow.defaultProps = {
  className: '',
};

/**
 * Headphones
 * @returns {JSX.Element}
 */
function Headphones() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36.713" height="36.713" viewBox="0 0 36.713 36.713">
      <path d="M190.78,225.734v-1.311a14.423,14.423,0,1,0-28.846,0v1.311A3.938,3.938,0,0,0,158,229.668v6.556a3.938,3.938,0,0,0,3.934,3.934h5.245a1.31,1.31,0,0,0,1.311-1.311v-11.8a1.31,1.31,0,0,0-1.311-1.311h-2.622v-1.311a11.8,11.8,0,1,1,23.6,0v1.311h-2.622a1.31,1.31,0,0,0-1.311,1.311v11.8a1.31,1.31,0,0,0,1.311,1.311h2.622a1.312,1.312,0,0,1-1.311,1.311H181.36a3.928,3.928,0,0,0-3.692-2.622h-2.622a3.934,3.934,0,1,0,0,7.867h2.622a3.928,3.928,0,0,0,3.692-2.622h5.486a3.938,3.938,0,0,0,3.934-3.934,3.938,3.938,0,0,0,3.934-3.934v-6.556A3.938,3.938,0,0,0,190.78,225.734Zm-24.913,11.8h-3.934a1.312,1.312,0,0,1-1.311-1.311v-6.556a1.312,1.312,0,0,1,1.311-1.311h3.934Zm11.8,6.556h-2.622a1.311,1.311,0,0,1,0-2.622h2.622a1.311,1.311,0,0,1,0,2.622Zm14.423-7.867a1.312,1.312,0,0,1-1.311,1.311h-3.934v-9.178h3.934a1.312,1.312,0,0,1,1.311,1.311Z" transform="translate(-158 -210)" />
    </svg>
  );
}

/**
 * Chat
 * @returns {JSX.Element}
 */
function Chat() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32.236" height="29.55" viewBox="0 0 32.236 29.55">
      <path d="M32.207,5H8.03A4.034,4.034,0,0,0,4,9.03V25.148a4.034,4.034,0,0,0,4.03,4.03H9.373v4.03a1.343,1.343,0,0,0,2.089,1.118l7.721-5.147H32.207a4.034,4.034,0,0,0,4.03-4.03V9.03A4.034,4.034,0,0,0,32.207,5ZM33.55,25.148a1.345,1.345,0,0,1-1.343,1.343H18.775a1.351,1.351,0,0,0-.745.226l-5.97,3.98V27.834a1.344,1.344,0,0,0-1.343-1.343H8.03a1.345,1.345,0,0,1-1.343-1.343V9.03A1.345,1.345,0,0,1,8.03,7.686H32.207A1.345,1.345,0,0,1,33.55,9.03Z" transform="translate(-4 -5)" />
      <path d="M15.39,13.385a2.117,2.117,0,0,0-.161.2,1.017,1.017,0,0,0-.121.242.854.854,0,0,0-.081.242,1.82,1.82,0,0,0-.027.269,1.343,1.343,0,1,0,.39-.954Z" transform="translate(-0.225 -2.25)" />
      <path d="M10.833,13.107a1.387,1.387,0,0,0-.443.282,1.362,1.362,0,0,0,0,1.907,1.387,1.387,0,0,0,.443.282,1.337,1.337,0,0,0,.51.107,1.349,1.349,0,0,0,.954-2.3A1.346,1.346,0,0,0,10.833,13.107Z" transform="translate(-1.941 -2.254)" />
      <path d="M20.833,13.106a1.551,1.551,0,0,0-.443.282,1.412,1.412,0,0,0-.39.954,1.82,1.82,0,0,0,.027.269.854.854,0,0,0,.081.242,1.017,1.017,0,0,0,.121.242l.161.2a1.551,1.551,0,0,0,.443.282,1.337,1.337,0,0,0,.51.107,1.349,1.349,0,0,0,.954-2.3A1.367,1.367,0,0,0,20.833,13.106Z" transform="translate(1.491 -2.253)" />
    </svg>
  );
}

/**
 * Gas Station (tradeIn Step#2)
 */
function GasStation() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.625" height="19" viewBox="0 0 16.625 19">
      <g transform="translate(-129 -304)">
        <rect width="3.563" height="3.563" transform="translate(133.75 307.563)" />
        <path d="M145.45,310.107l-2.379-2.38a.594.594,0,0,0-.84.84l2.205,2.205v6.879a.594.594,0,0,1-1.187,0V312.9a1.783,1.783,0,0,0-1.781-1.781h-.594v-4.745A2.382,2.382,0,0,0,138.5,304h-5.937a2.382,2.382,0,0,0-2.375,2.375v15.438h-.594a.594.594,0,0,0,0,1.188h11.875a.594.594,0,0,0,0-1.187h-.594v-9.5h.594a.6.6,0,0,1,.594.594v4.75a1.781,1.781,0,0,0,3.563,0v-7.125A.589.589,0,0,0,145.45,310.107Zm-12.888-3.139a.588.588,0,0,1,.594-.594h4.75a.588.588,0,0,1,.594.594v4.75a.588.588,0,0,1-.594.594h-4.75a.588.588,0,0,1-.594-.594Z" />
      </g>
    </svg>
  );
}

/**
 * Body Type (tradeIn Step#2)
 */
function BodyType() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15.75" viewBox="0 0 21 15.75">
      <g transform="translate(-80 -114)">
        <path d="M83.746,115.193a.654.654,0,0,0-.928,0l-1.505,1.5v-.385a.656.656,0,0,0-1.312,0v1.969a.656.656,0,0,0,.656.656h1.969a.656.656,0,1,0,0-1.312H82.24l1.505-1.5A.657.657,0,0,0,83.746,115.193Z" transform="translate(0 0.312)" />
        <path d="M99.558,115.511l-1.312-1.318a.656.656,0,1,0-.928.928l.2.2H84.656a.656.656,0,0,0,0,1.312H97.505l-.188.186a.656.656,0,1,0,.928.928l1.312-1.306A.657.657,0,0,0,99.558,115.511Z" transform="translate(1.25)" />
        <g transform="translate(80 120.562)">
          <path d="M100.943,124.053l-.693-1.572a.65.65,0,0,0-.466-.377l-5.5-1.135-3-1.578a3.633,3.633,0,0,0-1.63-.391h-3.8a4.205,4.205,0,0,0-1.874.7c-.39.264-1.328,1.012-1.658,1.277l-1.5.36a.657.657,0,0,0-.5.642l.008.959h.324a.656.656,0,1,1,0,1.312h-.394l-.253,1.471a.656.656,0,0,0,.521.755l2.091.4h0a2.625,2.625,0,1,1,5.25,0h5.25a2.625,2.625,0,1,1,5.25,0h1.969a.656.656,0,0,0,.656-.656v-1.9A.633.633,0,0,0,100.943,124.053Z" transform="translate(-80 -119)" />
          <circle cx="1.312" cy="1.312" r="1.312" transform="translate(3.938 6.562)" />
          <circle cx="1.312" cy="1.312" r="1.312" transform="translate(14.438 6.562)" />
        </g>
      </g>
    </svg>
  );
}

/**
 * Gears (tradeIn Step#2)
 */
function Gears() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.982" height="21.189" viewBox="0 0 20.982 21.189">
      <defs>
        <clipPath id="clip-path">
          <rect width="20.982" height="21.189" />
        </clipPath>
      </defs>
      <g transform="translate(-414.813 -304.031)">
        <g transform="translate(414.813 304.032)">
          <g clipPath="url(#clip-path)">
            <path d="M427.953,316.9a5.788,5.788,0,0,0,.067-.883,5.889,5.889,0,0,0-.066-.876l1.46-1.145a.888.888,0,0,0,.219-1.136l-.942-1.631a.889.889,0,0,0-1.1-.379l-1.719.694a5.575,5.575,0,0,0-1.519-.879l-.262-1.836a.886.886,0,0,0-.873-.758H421.34a.886.886,0,0,0-.873.758l-.261,1.837a5.61,5.61,0,0,0-1.512.877l-1.727-.694a.889.889,0,0,0-1.1.379l-.94,1.631a.885.885,0,0,0,.222,1.137l1.457,1.137a5.788,5.788,0,0,0-.067.883,5.7,5.7,0,0,0,.067.876l-1.46,1.145a.889.889,0,0,0-.22,1.137l.942,1.631a.89.89,0,0,0,1.1.378l1.719-.692a5.587,5.587,0,0,0,1.519.877l.261,1.837a.888.888,0,0,0,.875.757h1.883a.886.886,0,0,0,.873-.758l.262-1.837a5.6,5.6,0,0,0,1.511-.876l1.728.692a.886.886,0,0,0,1.094-.378l.942-1.631a.887.887,0,0,0-.222-1.137Zm-5.672,2.208a3.09,3.09,0,1,1,3.09-3.091,3.094,3.094,0,0,1-3.09,3.091Zm0,0" transform="translate(-414.813 -302.774)" />
            <path d="M431.853,308.859a2.059,2.059,0,0,0,0-.828l.8-.6a.442.442,0,0,0,.115-.573l-.715-1.237a.442.442,0,0,0-.553-.186l-.915.387a3.239,3.239,0,0,0-.723-.43l-.122-.973a.443.443,0,0,0-.438-.386H427.87a.442.442,0,0,0-.438.386l-.122.973a3.239,3.239,0,0,0-.723.43l-.915-.387a.442.442,0,0,0-.555.186l-.713,1.237a.442.442,0,0,0,.115.573l.8.6a3.057,3.057,0,0,0-.042.414,3.282,3.282,0,0,0,.041.413l-.795.6a.442.442,0,0,0-.117.573l.715,1.235a.441.441,0,0,0,.553.186l.915-.387a3.278,3.278,0,0,0,.724.43l.122.972a.442.442,0,0,0,.437.388H429.3a.442.442,0,0,0,.438-.387l.122-.972a3.31,3.31,0,0,0,.723-.43l.915.386a.44.44,0,0,0,.555-.186l.713-1.235a.442.442,0,0,0-.115-.573Zm-3.269,1.352a1.766,1.766,0,1,1,1.766-1.765,1.764,1.764,0,0,1-1.766,1.765Zm0,0" transform="translate(-411.845 -304.031)" />
          </g>
        </g>
      </g>
    </svg>
  );
}

/**
 * Transmission (tradeIn Step#2)
 */
function Transmission() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g transform="translate(-416 -112)">
        <path d="M420,124a1,1,0,0,0-1,1h12a1,1,0,0,0-1-1Z" />
        <path d="M417,126a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1Z" transform="translate(0)" />
        <path d="M430.47,112.2a2.5,2.5,0,0,0-2.381,4.368L426.221,122H423a1,1,0,0,0-1,1h8a1,1,0,0,0-1-1h-1.694l1.7-5.048a2.5,2.5,0,0,0,1.46-4.756Z" transform="translate(0 0)" />
      </g>
    </svg>
  );
}

/**
 * Doors (tradeIn Step#2)
 */
function Doors() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14.25" viewBox="0 0 19 14.25">
      <path d="M290.561,119.847l-1.8-2.912a3.735,3.735,0,0,0-3.167-1.748h-4.628a3.735,3.735,0,0,0-3.167,1.748l-.2.323a5.5,5.5,0,0,0-2.624-3.205.611.611,0,0,0-.246-.053h-2.137a.594.594,0,0,0-.594.594v10.688a.594.594,0,0,0,.594.594h2.969v.321a2.057,2.057,0,0,0,2.056,2.054h.131a2.051,2.051,0,0,0,1.912-1.318l.118.122a.6.6,0,0,0,.45.207h6.106a.6.6,0,0,0,.45-.207l.118-.122a2.053,2.053,0,0,0,1.913,1.318h.131A2.057,2.057,0,0,0,291,126.2v-2.7h-1.781a.594.594,0,0,1,0-1.187H291v-.918A2.945,2.945,0,0,0,290.561,119.847Zm-17.373-1.1v-3.562h1.4a4.489,4.489,0,0,1,2.114,3.528l-.021.034Zm4.156,4.75h-1.781v-1.187h1.781a.594.594,0,0,1,0,1.188Zm8.313,1.188h-4.75a.594.594,0,0,1,0-1.187h4.75a.594.594,0,0,1,0,1.188Zm-2.375-4.552a21.648,21.648,0,0,1-5.344-.793l-.194-.053,1.068-1.73a2.542,2.542,0,0,1,2.157-1.184H285.6a2.542,2.542,0,0,1,2.156,1.184l1.068,1.73A21.893,21.893,0,0,1,283.281,120.136Z" transform="translate(-272 -114)" />
    </svg>
  );
}

/**
 * Speedometer (tradeIn Step#2)
 */
function Speedometer() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
      <g transform="translate(-224 -256)">
        <path d="M232.5,256a8.5,8.5,0,1,0,8.5,8.5A8.5,8.5,0,0,0,232.5,256Zm2.2,3.634.531-.924a.528.528,0,0,1,.914.531l-.531.924a.526.526,0,0,1-.457.266.48.48,0,0,1-.266-.074A.524.524,0,0,1,234.7,259.634Zm-2.731-1.509a.531.531,0,0,1,1.063,0v1.063a.531.531,0,0,1-1.062,0Zm.531,4.516a1.855,1.855,0,0,1,1.275.51l3.974-2.3a.537.537,0,0,1,.733.191.525.525,0,0,1-.2.723l-3.974,2.306a1.857,1.857,0,1,1-1.806-1.434Zm-6.906,1.859a.526.526,0,0,1,.531-.531h1.063a.531.531,0,0,1,0,1.063h-1.062A.526.526,0,0,1,225.594,264.5Zm2.571,3.113-.924.531a.456.456,0,0,1-.266.074.531.531,0,0,1-.266-.988l.924-.531a.528.528,0,1,1,.531.914Zm.191-5.5a.526.526,0,0,1-.457.266.48.48,0,0,1-.266-.074l-.924-.531a.528.528,0,0,1,.531-.914l.924.531A.524.524,0,0,1,228.356,262.109Zm1.753-1.753a.48.48,0,0,1-.266.074.526.526,0,0,1-.457-.266l-.531-.924a.528.528,0,0,1,.914-.531l.531.924A.524.524,0,0,1,230.109,260.356Zm3.984,10.519h-3.187a.531.531,0,0,1,0-1.062h3.188a.531.531,0,0,1,0,1.063Zm4.388-2.922a.526.526,0,0,1-.457.266.456.456,0,0,1-.266-.074l-.924-.531a.528.528,0,1,1,.531-.914l.924.531A.524.524,0,0,1,238.482,267.953Zm.393-2.922h-1.062a.531.531,0,0,1,0-1.062h1.063a.531.531,0,0,1,0,1.063Zm-6.375.266a.8.8,0,1,0-.8-.8A.8.8,0,0,0,232.5,265.3Z" />
      </g>
    </svg>
  );
}

/**
 * Speedometer (tradeIn Step#2)
 */
function Configuration() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16">
      <g transform="translate(-34 -1328)">
        <path d="M44,1329a1,1,0,0,1,1,1v12a1,1,0,0,1-1,1H36a1,1,0,0,1-1-1v-12a1,1,0,0,1,1-1h8m0-1H36a2,2,0,0,0-2,2v12a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2v-12a2,2,0,0,0-2-2Z" />
        <path d="M38,1334.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,0,1h-5A.5.5,0,0,1,38,1334.5Z" />
        <path d="M38,1331.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,0,1h-5A.5.5,0,0,1,38,1331.5Z" />
        <path d="M38,1337.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,0,1h-5A.5.5,0,0,1,38,1337.5Z" />
        <path d="M38,1340.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,0,1h-5A.5.5,0,0,1,38,1340.5Z" />
        <path d="M36,1334.5a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,0,1h0A.5.5,0,0,1,36,1334.5Z" />
        <path d="M36,1331.5a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,0,1h0A.5.5,0,0,1,36,1331.5Z" />
        <path d="M36,1337.5a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,0,1h0A.5.5,0,0,1,36,1337.5Z" />
        <path d="M36,1340.5a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,0,1h0A.5.5,0,0,1,36,1340.5Z" />
      </g>
    </svg>
  );
}

export {
  Personal, TradeIn, Services, Payment, Documents, Summary, PayPal,
  Arrow, Headphones, Chat, GasStation,
  BodyType, Gears, Transmission, Doors, Speedometer, Configuration,
};
